import React from 'react';
//import $ from 'jquery';
import { Link } from 'react-router-dom';
import { BsArrowRight } from "react-icons/bs";
import Img1 from '../../images/Concept Drawings & Renderings/242 Park - Concept Drawing 2(1).jpg';
import Img2 from '../../images/Concept Drawings & Renderings/242 Park - Concept Drawing 2.jpg';
import Img3 from '../../images/Concept Drawings & Renderings/242 Park - Concept Drawing 3.jpg';
import Img4 from '../../images/Concept Drawings & Renderings/242 Park - Concept Drawing 4.jpg';
import Img5 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Draft 1.jpg';
import Img6 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Draft 2.jpg';
import Img7 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Draft 3.jpg';
import Img8 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Draft 4.jpg';
import Img9 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Site 1.jpg';
import Img10 from '../../images/Concept Drawings & Renderings/242 Park - Sign Posting 1.jpeg';
import Img11 from '../../images/Concept Drawings & Renderings/242 Park - Sign Posting 2.jpeg';


export default () => (

	<div className='project-template'>
		<h4></h4>
		<h4>More Coming Soon</h4>
		<p>Stay tuned as we build brick by brick and lot by lot.</p>

		<Link className="proj-button" to='/contactpage'>
			<button className="projectpage-button">GET IN TOUCH</button>
		</Link>

		<div className="project-split">
			<img className="project-img" src={Img2}></img>
			<img className="project-img" src={Img3}></img>
			<img className="project-img" src={Img4}></img>
			<img className="project-img" src={Img5}></img>
			<img className="project-img" src={Img6}></img>
			<img className="project-img" src={Img7} ></img>
		</div>


	</div>


);
